import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { SaveJobButton } from "@/components/SaveJobButton";
import { MapPin, Building2, DollarSign, Globe, Layers, Clock, Star } from "lucide-react";

export const JobCard = ({ job, saved, onToggleSave, showSave }) => {
  const navigate = useNavigate();
  const salary = job.salary_not_disclosed ? "Not disclosed" : job.salary_range || "Not disclosed";

  return (
    <div
      data-testid={`job-card-${job.job_id}`}
      onClick={() => navigate(`/jobs/${job.job_id}`)}
      className={`bg-white rounded-xl p-6 transition-all duration-200 shadow-sm hover:shadow-md cursor-pointer group ${job.featured ? "border-2 border-amber-400 ring-2 ring-amber-100" : "border border-slate-200 hover:border-amber-500/60"}`}
    >
      {job.featured && (
        <div className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-amber-600 mb-2" data-testid={`featured-badge-${job.job_id}`}>
          <Star className="h-3 w-3" fill="currentColor" /> Featured
        </div>
      )}
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="font-display font-bold text-lg text-navy-800 group-hover:text-amber-600 transition-colors truncate">{job.job_title}</h3>
          <div className="flex items-center gap-1.5 text-sm text-slate-500 mt-1">
            <Building2 className="h-3.5 w-3.5" /> {job.company_name}
          </div>
        </div>
        <div className="shrink-0 flex items-center gap-2">
          {typeof job.days_left === "number" && (
            <span className="flex items-center gap-1 text-[11px] font-semibold text-slate-400">
              <Clock className="h-3 w-3" /> {job.days_left}d
            </span>
          )}
          {showSave && <SaveJobButton jobId={job.job_id} saved={saved} onToggle={onToggleSave} />}
        </div>
      </div>

      <div className="flex flex-wrap gap-2 mt-4">
        <Badge variant="secondary" className="bg-slate-100 text-slate-700 font-medium gap-1">
          <MapPin className="h-3 w-3" /> {job.remote ? "Remote" : `${job.city}, ${job.state}`}
        </Badge>
        {job.remote && !job.multi_state && <Badge className="bg-emerald-100 text-emerald-700 hover:bg-emerald-100 gap-1"><Globe className="h-3 w-3" /> Remote</Badge>}
        {job.multi_state && <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100 gap-1"><Layers className="h-3 w-3" /> Multi-State</Badge>}
        {job.employment_type && job.employment_type !== "Full-time" && (
          <Badge variant="outline" className="border-slate-300 text-slate-600">{job.employment_type}</Badge>
        )}
      </div>

      <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-100">
        <span className="flex items-center gap-1 text-sm font-semibold text-navy-800">
          <DollarSign className="h-4 w-4 text-emerald-600" /> {salary}
        </span>
        {job.safety_level && <span className="text-xs uppercase tracking-wide font-semibold text-amber-600">{job.safety_level}</span>}
      </div>
    </div>
  );
};
